import { ErrorCardContent } from "../cards/ErrorCard";
import { type ConfigItem, FactSetWidget } from "./FactsetWidget";
type SearchAssetsTableProps = {
  searchTerm: string;
  symbolLinkClick?: (event: any) => void;
  tab: string;
};

export function SearchAssetsTable({
  symbolLinkClick,
  searchTerm,
  tab,
}: SearchAssetsTableProps) {
  if (!searchTerm || searchTerm.length <= 1) {
    return (
      <ErrorCardContent>
        Search term must be at least 2 characters long
      </ErrorCardContent>
    );
  }

  const config = [
    { type: "attribute", key: "identifierEmitted", value: "tickerRegion" },
    { type: "attribute", key: "assetClasses", value: ["stock", "etf", "fund"] },
    {
      type: "attribute",
      key: "searchTerm",
      value: searchTerm,
    },
    {
      type: "attribute",
      key: "criteria",
      value: {
        generic: {
          validation: {
            market: {
              selection: {
                restrict: { ids: [42, 45, 46, 77, 78, 555, 179, 388, 431] },
              },
            },
          },
        },
      },
    },
  ] as ConfigItem[];

  if (tab) {
    config.push({ type: "attribute", key: "defaultAssetClass", value: tab });
  }

  if (symbolLinkClick) {
    config.push({ type: "event", key: "row-click", value: symbolLinkClick });
  }

  return <FactSetWidget config={config} widget="search-assets-table" />;
}
